import { HomeContainer } from "../containers/home"

export const Home = () => {
    return (
        <HomeContainer />
    )
}